import { createApp } from 'vue'
import FArticleFilter from '~/js/components/articleFilter'
import FLinkCard from '~/js/components/linkCard'
import { LinkItem } from '~/js/models/linkItem'
import {
  favouriteArticleHandles,
  favouriteCoordinateHandles,
  isDesktop,
} from '~/js/templates/index/helpers'

const ID_BLOG_ARTICLES = 'js-blogArticles'

document.addEventListener('DOMContentLoaded', () => {
  const element = document.getElementById(ID_BLOG_ARTICLES)
  if (!element) return

  const { articleCount, imageRatioPc, imageRatioSp, blogHandle } =
    element.dataset

  const ratio = isDesktop() ? Number(imageRatioPc) : Number(imageRatioSp) || 1

  const linkItems = JSON.parse(element.dataset.linkItems)
    .slice(0, Number(articleCount))
    .map((linkItem) => {
      const url = `/blogs/${blogHandle}/${linkItem.handle}`
      const isFavourite = [
        ...favouriteArticleHandles,
        ...favouriteCoordinateHandles,
      ].includes(linkItem.handle)
      return new LinkItem(linkItem, url, isFavourite)
    })

  createApp({
    name: 'TemplatesBlogArticles',
    data() {
      return {
        baseUrl: `/blogs/${blogHandle}`,
        isDesktop: isDesktop(),
        linkItems,
        ratio,
      }
    },
    components: {
      FArticleFilter,

      FLinkCard,
    },
  }).mount(element)
})
